import { render, staticRenderFns } from "./DemandTableContainer.vue?vue&type=template&id=6c597398&"
import script from "./DemandTableContainer.vue?vue&type=script&lang=ts&"
export * from "./DemandTableContainer.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports